import script from "./ValidateToken.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidateToken.vue?vue&type=script&setup=true&lang=js"

import "./ValidateToken.vue?vue&type=style&index=0&id=09648b5e&lang=scss"

const __exports__ = script;

export default __exports__